import { Box, Button, Stack } from '@mui/material'
import { useSearchParams } from '@edge/spark/utils-react-router'
import { openActionDrawerWorkflow } from './action-drawer.store'
import { defaultWorkflows } from './defaultWorkflows'
import { ActiveActionDrawerWrapper } from './ActiveActionDrawerWrapper'

export const SelectWorkflowButtons = () => {
    const { wf } = useSearchParams()

    if (!wf) return null

    const workflowsToShow = wf.split(',')

    const displayedWorkflows = Object.entries(defaultWorkflows)
        .filter(([key]) => workflowsToShow.includes(key))
        .flatMap(([_, wf]) => wf)

    return (
        <Stack direction="row" gap={1}>
            {displayedWorkflows.map((wf) => (
                <Box key={wf.id}>
                    <Button size="small" variant="contained" onClick={() => openActionDrawerWorkflow(wf)}>
                        {wf.text}
                    </Button>
                </Box>
            ))}
            <ActiveActionDrawerWrapper />
        </Stack>
    )
}
